import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { logout } from '../services/api';
import { useState, useEffect } from 'react';

function Layout() {
  const location = useLocation();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setMobileMenuOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      localStorage.removeItem('user');
      localStorage.removeItem('isAuthenticated');
      navigate('/login');
    }
  };

  const navLinkStyle = (path) => ({
    color: location.pathname === path ? '#C8342B' : 'white',
    textDecoration: 'none',
    fontSize: '15px',
    padding: '10px 16px',
    borderRadius: '4px',
    transition: 'all 0.3s',
    fontWeight: location.pathname === path ? '600' : '500',
    background: location.pathname === path ? 'white' : 'transparent',
    display: 'inline-block'
  });

  // Define all menu items
  const allMenuItems = [
    { path: '/', label: 'Dashboard' },
    { path: '/customers', label: 'Customers' },
    { path: '/inquiries', label: 'Inquiries' },
    { path: '/orders', label: 'Orders' },
    { path: '/deliveries', label: 'Deliveries' },
    // { path: '/invoices', label: 'Invoices' },
    { path: '/samples', label: 'Samples' },
    { path: '/followups', label: 'Follow-ups' },
    { path: '/users', label: 'Users', adminOnly: true }
  ];

  // Filter menu items based on user role
  const menuItems = allMenuItems.filter(item => {
    // If item is admin-only and user is not admin, exclude it
    if (item.adminOnly && user.role !== 'admin') {
      return false;
    }
    return true;
  });

  const handleMenuClick = (path) => {
    navigate(path);
    setMobileMenuOpen(false);
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Top Navigation Bar */}
      <div style={{
        background: '#3D1F1F',
        color: 'white',
        padding: isMobile ? '10px 15px' : '15px 30px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'relative'
      }}>
        {/* Logo & Hamburger */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          {isMobile && (
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              style={{
                background: 'none',
                border: 'none',
                color: 'white',
                fontSize: '24px',
                cursor: 'pointer',
                padding: '5px',
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
              }}
            >
              <div style={{ width: '25px', height: '3px', background: 'white', borderRadius: '2px' }}></div>
              <div style={{ width: '25px', height: '3px', background: 'white', borderRadius: '2px' }}></div>
              <div style={{ width: '25px', height: '3px', background: 'white', borderRadius: '2px' }}></div>
            </button>
          )}
          <img src="/logo.jpeg" alt="Sai Plywood" style={{ height: isMobile ? '35px' : '50px' }} />
        </div>

        {/* Desktop Navigation Menu */}
        {!isMobile && (
          <nav style={{ flex: 1, marginLeft: '30px' }}>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0,
              display: 'flex',
              gap: '8px',
              alignItems: 'center',
              flexWrap: 'wrap'
            }}>
              {menuItems.map(item => (
                <li key={item.path}>
                  <Link to={item.path} style={navLinkStyle(item.path)}>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        )}

        {/* User Info & Logout */}
        <div style={{ display: 'flex', alignItems: 'center', gap: isMobile ? '8px' : '15px' }}>
          {!isMobile && (
            <div style={{ fontSize: '14px' }}>
              <div style={{ fontWeight: '600' }}>{user.name || user.username}</div>
              <div style={{ fontSize: '12px', color: '#ecf0f1' }}>{user.role}</div>
            </div>
          )}
          <button
            onClick={handleLogout}
            style={{
              padding: isMobile ? '6px 12px' : '8px 16px',
              background: '#C8342B',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: isMobile ? '12px' : '14px',
              fontWeight: '500'
            }}
          >
            {isMobile ? 'Out' : 'Logout'}
          </button>
        </div>
      </div>

      {/* Mobile Menu Drawer */}
      {isMobile && mobileMenuOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.5)',
            zIndex: 1000
          }}
          onClick={() => setMobileMenuOpen(false)}
        >
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '80%',
              maxWidth: '300px',
              height: '100%',
              background: '#3D1F1F',
              boxShadow: '2px 0 8px rgba(0,0,0,0.2)',
              overflowY: 'auto',
              padding: '20px'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ marginBottom: '30px', paddingBottom: '20px', borderBottom: '1px solid rgba(255,255,255,0.2)' }}>
              <div style={{ color: 'white', fontWeight: '600', fontSize: '16px' }}>{user.name || user.username}</div>
              <div style={{ color: '#ecf0f1', fontSize: '12px', marginTop: '4px' }}>{user.role}</div>
            </div>

            <nav>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {menuItems.map(item => (
                  <li key={item.path} style={{ marginBottom: '8px' }}>
                    <div
                      onClick={() => handleMenuClick(item.path)}
                      style={{
                        padding: '12px 16px',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        background: location.pathname === item.path ? 'white' : 'transparent',
                        color: location.pathname === item.path ? '#C8342B' : 'white',
                        fontWeight: location.pathname === item.path ? '600' : '500',
                        fontSize: '14px',
                        transition: 'all 0.2s'
                      }}
                    >
                      {item.label}
                    </div>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>
      )}

      {/* Main Content */}
      <div style={{
        flex: 1,
        padding: isMobile ? '15px' : '30px',
        background: '#ecf0f1'
      }}>
        <Outlet />
      </div>
    </div>
  );
}

export default Layout;
